var _path, _path2, _path3, _path4, _path5, _circle;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgBrUploadPhoto = function SvgBrUploadPhoto(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 41,
    viewBox: "0 0 60 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5181 6.56616H32.2814L37.8045 13.9674H46.1975V38.8701H2.28027V13.9674H10.5763L15.5181 6.56616Z",
    stroke: "#151515",
    strokeWidth: 3.3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6262 9.68206L58.5709 3.0752",
    stroke: "#151515",
    strokeWidth: 3.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9584 14.2525L58.9187 14.2524",
    stroke: "#151515",
    strokeWidth: 3.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7804 7.39203L47.9174 1.18514",
    stroke: "#151515",
    strokeWidth: 3.3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4541 12.1765H28.1364",
    stroke: "#151515",
    strokeWidth: 3.3,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.2389,
    cy: 25.0172,
    r: 6.95021,
    stroke: "#0157FF",
    strokeWidth: 3.3
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBrUploadPhoto);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "assets/BR_upload_photo.0d6849dd131d21293a12454db04bdc90.svg";